import { render, staticRenderFns } from "./Rl4.vue?vue&type=template&id=15dc3314&"
import script from "./Rl4.vue?vue&type=script&lang=js&"
export * from "./Rl4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports